import React, { Component } from 'react';
import * as HELPERS from '../_helpers/url.helpers';
import * as CONSTANTS from '../_constants';
import { Tabs, Tab } from 'react-bootstrap';
import { SectionLinks, SectionList, SectionSearch } from '../_components';
import { Html5Entities } from 'html-entities';
import ReactLoading from 'react-loading';
import * as Scroll from 'react-scroll';
import { Element, scrollSpy } from 'react-scroll'

let thisScroller = Scroll.scroller;
//import '../App.css';

const BASE_SECTION = CONSTANTS.SECTIONS.BASE_SECTION;
const entities = new Html5Entities();

class Summaries extends Component {

	constructor(props) {

		super(props);

		this.state = {
			loadCount : 0,
			key: 1,
			fetchingList: true,
			fetching: true,
			search : {
				term : '',
				type : 'title',
				key  : 'Title'
			},
			currentApiUrl : null,
			[CONSTANTS.SECTIONS.CATEGORY]: null,
			[CONSTANTS.SECTIONS.SUMMARY] : null,
			[CONSTANTS.SECTIONS.SUMMARIES]: {
				links: [],
				meta: {},
				title: ''
			},
			[CONSTANTS.SECTIONS.CATEGORIES]: [],
			[CONSTANTS.SECTIONS.SPECIALTIES]: [],
			[CONSTANTS.SECTIONS.ORGANIZATIONS]: [],
			[CONSTANTS.SECTIONS.PROFESSIONS]: []
		}
	}

	componentDidMount() {
		//get categories
		this.fetchCategories();
		//get specialties
		this.fetchSpecialties();
		//get professions
		this.fetchProfessions();
		//get organizations
		this.fetchOrganizations();

		//default results
		this.fetchListBySectionAndTitle(CONSTANTS.SECTIONS.CATEGORIES, CONSTANTS.SECTIONS.DEFAULT.TITLE, null);
		
		document.addEventListener('scroll', this.trackScrolling);
		
		scrollSpy.update();
	}

	componentWillUnmount() {
		document.removeEventListener('scroll', this.trackScrolling);
	}

	isBottom(el) {
		return el.getBoundingClientRect().bottom <= window.innerHeight;
	}
	
	trackScrolling = () => {
		const wrappedElement = document.getElementById('summaries-wrapper');
		if (this.isBottom(wrappedElement) && this.moreDataExists()) {
			this.fetchAdditionalSummaries();
		}
	};

	scrollTo() {
		thisScroller.scrollTo('summaries-list', {
			duration: 1000,
			smooth: true,
			offset: -200
		});
	}

	/**
	 * Get the usable data from the result
	 * 
	 * @param {array} data 
	 * @param {string} section 
	 */
	getValuesFromSection(data, section) {
		
		if(!data.output[section]) return data.output;

		return {
			data: Object.values(data.output[section]),
			meta: data.output.meta
		}
	}

	moreDataExists() {

		let section = this.state[CONSTANTS.SECTIONS.SUMMARIES];
		let moreData = parseInt(section.meta.start) < section.meta.count;

		return moreData;
	}

	/**
	 * Fetches data from api based on section and url
	 * 
	 * @param {string} url 
	 * @param {string} section 
	 */
	fetchApiData(url, section, callback) {
		
		let currentLoadCount = this.state.loadCount;

		this.setState({ loadCount: currentLoadCount + 1, currentApiUrl: url})

		fetch(url)
			.then(response => response.json())
			.then((data) => {
				if(section) {
					return this.getValuesFromSection(data, section);
				} else {
					return data.output;
				}
			})
			.then((data) => {
				
				this.setState({ fetching: false, fetchingList: false, loadingMore: false }, () => {
					console.log(data);
					if(currentLoadCount > 0 && data.data && data.data.length < 1) {
						this.setState({noData: true})
					}  else {
						this.setState({noData: false})
					}
				});

				callback()(data, section)
				
			}).catch((e)=>{
				console.error(e);
				this.setState({ fetching: false, fetchingList: false });
			});
	}

	/**
	 * 
	 */
	renderSectionData() {
		return (data, section) => {
			let links = data.data.map((data) => {
				
				let slug = HELPERS.generateSlugFromTitle(data);
				let title = entities.decode(data);

				return {
					title: title,
					slug: slug,
					section: section,
					link: HELPERS.generateSummaryLinkFromTypeSectionAndTitle(BASE_SECTION, section, slug)
				}
			})

			this.setState({ [section]: links })
		}

	}

	/**
	 * 
	 */
	renderSectionSummaryData() {
		return (data, section) => {		

			if(data.length < 1) return;
			let extendedLinks = [];
			let links = data.data.map((link) => {

				return {
					data: link,
					section: section
				}
			})

			if(data.meta.start >= data.meta.max) {
				extendedLinks = this.state[CONSTANTS.SECTIONS.SUMMARIES].links.concat(links);
			} else {
				extendedLinks = links;
			}
			
			this.setState({ [section]: { title: data.meta.term, links: extendedLinks, meta: data.meta } })
	
		}
	}

	

	/**
	 * Fetches summary categories from my.guidelinecentral.com/api
	 */
	fetchCategories() {

		let type    = CONSTANTS.ENDPOINTS.GET_CATEGORIES;
		let section = CONSTANTS.SECTIONS.CATEGORIES;

		let url = HELPERS.generateAPIUrlTypeSectionAndTitle(type);
		this.setState({
			fetchingList: true
		});
		this.fetchApiData(url, section, this.renderSectionData.bind(this));
	}

	/**
	 * Fetches summary specialties from my.guidelinecentral.com/api
	 */
	fetchSpecialties() {
		let type = CONSTANTS.ENDPOINTS.GET_SPECIALTIES;
		let section = CONSTANTS.SECTIONS.SPECIALTIES;
		let url = HELPERS.generateAPIUrlTypeSectionAndTitle(type);

		this.fetchApiData(url, section, this.renderSectionData.bind(this));
	}

	/**
	 * Fetches summary professions from my.guidelinecentral.com/api
	 */
	fetchProfessions() {

		let type = CONSTANTS.ENDPOINTS.GET_PROFESSIONS;
		let section = CONSTANTS.SECTIONS.PROFESSIONS;
		let url = HELPERS.generateAPIUrlTypeSectionAndTitle(type);

		this.fetchApiData(url, section, this.renderSectionData.bind(this));
	}

	/**
	 * 
	 * @param {string} section 
	 * @param {string} title 
	 * @param {object} e 
	 */
	fetchSummariesBySearch(e) {
		if(e) {
			e.preventDefault();
		}
		
		let sectionSingular = CONSTANTS.SECTIONS.SEARCH;
		let type = HELPERS.getAPIActionFromSection(sectionSingular);
		let url  = HELPERS.generateAPIUrlTypeSectionAndTitle(type, sectionSingular);
		let et   = this.typeahead;
		let value = '';

		if(et) {
			value = et.componentNode.getElementsByTagName("input")[0].value;
		}
		
		if((this.state.search.type !== '' && this.state.search.term !== '') || (this.state.search.type !== '' && value !== "")) {
			url += `&type=${this.state.search.type.toLocaleLowerCase()}&term=${value !== '' ? value : this.state.search.term}`;
			this.fetchApiData(url, BASE_SECTION, this.renderSectionSummaryData.bind(this));
		} else {
			this.fetchListBySectionAndTitle(CONSTANTS.SECTIONS.CATEGORIES, CONSTANTS.SECTIONS.DEFAULT.TITLE, null);
		}

		if(this.state.loadCount >= 1) {
			this.scrollTo();
		}

	}

	fetchAdditionalSummaries() {

		let url  = this.state.currentApiUrl;
		let currentSummaries = this.state[CONSTANTS.SECTIONS.SUMMARIES];
		let currentStart, currentMax;

		this.setState({loadingMore:true});

		if(currentSummaries.links.length > 0) {
			
			currentStart = parseInt(currentSummaries.meta.start);
			currentMax   = parseInt(currentSummaries.meta.max);
			let matched = /(&retstart=)(\d+)([^&])/g
			
			if(url.match(matched)) {
				url = url.replace(matched, `$1${currentStart + currentMax}`);
			} else {
				url += `&retstart=${currentStart + currentMax}`;	
			}
		}
		
		if(this.state.currentApiUrl === url) {
			return;
		}

		this.fetchApiData(url, BASE_SECTION, this.renderSectionSummaryData.bind(this));
	}

	/**
	 * 
	 * @param {string} section 
	 * @param {strin} title 
	 * @param {object} e 
	 */
	fetchListBySectionAndTitle(section, title, e) {
		
		if(e) {
			e.preventDefault();
		}

		let sectionSingular = HELPERS.getSectionSingularForm(section);
		let type = HELPERS.getAPIActionFromSection(sectionSingular);
		let url = HELPERS.generateAPIUrlTypeSectionAndTitle(type, sectionSingular, title);
		
		if(this.state.loadCount >= 1) {
			this.scrollTo();
		}

		this.fetchApiData(url, BASE_SECTION, this.renderSectionSummaryData.bind(this));
	}

	/**
	 * 
	 * @param {string} target 
	 */
	onSearchTypeSelect(e, target) {
		
		e.preventDefault();
		
		let search = Object.assign({}, this.state.search, { type: target.type, key: target.key, term:  '' })
		this.setState({search})
	}

	/**
	 * 
	 * @param {object} e 
	 */
	onSearchInputChange(e, value) {
		let search;

		if(value) {
			search = Object.assign({}, this.state.search, { term: value, type: this.state.search.type })
		} else {
			search = Object.assign({}, this.state.search, { term: e.target.value, type: this.state.search.type })
		}
		
		this.setState({search})
	} 

	/**
	 * Fetches summary organizations from my.guidelinecentral.com/api
	 */
	fetchOrganizations() {

		let type = CONSTANTS.ENDPOINTS.GET_ORGANIZATIONS;
		let section = CONSTANTS.SECTIONS.ORGANIZATIONS;
		let url = HELPERS.generateAPIUrlTypeSectionAndTitle(type);

		this.fetchApiData(url, section, this.renderSectionData.bind(this));
	}

	/**
	 * 
	 * @param {string} key 
	 */
	handleSelect(key) {
		this.setState({ key })
	}

	/**
	 * Searches summaries in my.guidelinecentral.com/api
	 */
	search() { }

	render() {
		return (
			<div id="summaries-wrapper" className="container">
				<div className="row">
					<div className="col-md-12">
						<SectionSearch 
							data={this.state.search} 
							parent={this}
							options={this.state[CONSTANTS.SECTIONS.ORGANIZATIONS]} 
							onSearchInputChange={this.onSearchInputChange.bind(this)}
							callback={this.fetchSummariesBySearch.bind(this)}
							onSubmit={this.fetchSummariesBySearch.bind(this)} 
							onSearchTypeSelect={this.onSearchTypeSelect.bind(this)} />
					</div>
					<div className="col-md-12">
						<Tabs animation={false} defaultActiveKey={1} id="summaries-sections" activeKey={this.state.key} onSelect={this.handleSelect.bind(this)}>
							<Tab eventKey={1} title="Category">
							    { this.state.fetchingList && <span className="loading"><ReactLoading type="spinningBubbles" color="#0089BB"/></span>}
								<SectionLinks data={this.state[CONSTANTS.SECTIONS.CATEGORIES]} onClick={this.fetchListBySectionAndTitle.bind(this)} />
							</Tab>
							<Tab eventKey={2} title="Specialty">
								{ this.state.fetchingList && <span className="loading"><ReactLoading type="spinningBubbles" color="#0089BB"/></span>}
								<SectionLinks data={this.state[CONSTANTS.SECTIONS.SPECIALTIES]} onClick={this.fetchListBySectionAndTitle.bind(this)} />
							</Tab>
							<Tab eventKey={3} title="Intended Users">
								{ this.state.fetchingList && <span className="loading"><ReactLoading type="spinningBubbles" color="#0089BB"/></span>}
								<SectionLinks data={this.state[CONSTANTS.SECTIONS.PROFESSIONS]} onClick={this.fetchListBySectionAndTitle.bind(this)} />
							</Tab>
							<Tab eventKey={4} title="Authoring">
								{ this.state.fetchingList && <span className="loading"><ReactLoading type="spinningBubbles" color="#0089BB"/></span>}
								<SectionLinks data={this.state[CONSTANTS.SECTIONS.ORGANIZATIONS]} onClick={this.fetchListBySectionAndTitle.bind(this)} />
							</Tab>
						</Tabs>
					</div>
				</div>
				<Element name="summaries-list">
					<div id="summaries-list">
						{!this.state.fetching &&
						this.state[CONSTANTS.SECTIONS.SUMMARIES].title && <h2>{ this.state[CONSTANTS.SECTIONS.SUMMARIES].title }</h2>}
						
						{ this.state.fetching && <span className="loading"><ReactLoading type="spinningBubbles" color="#0089BB"/></span> }
						{
							!this.state.fetching && 
							this.state[CONSTANTS.SECTIONS.SUMMARIES].links && this.state[CONSTANTS.SECTIONS.SUMMARIES].links.length > 0 &&
							<SectionList onClick={this.fetchListBySectionAndTitle.bind(this)} data={this.state[CONSTANTS.SECTIONS.SUMMARIES].links} />
						}
						{this.state.noData && <span className="no-data">No additional summaries data found...</span>}
					</div>
				</Element>
				{ this.state.loadingMore && <span className="load-more" style={{marginBottom:440}}><ReactLoading type="spinningBubbles" color="#0089BB"/></span> }
			</div>
		);
	}
}

export default Summaries;
